// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".svg-icon[data-v-1034d9b8]{overflow:hidden}.svg-icon.click-able[data-v-1034d9b8]:hover{opacity:.8}.svg-external-icon[data-v-1034d9b8]{background-color:currentColor;-webkit-mask-size:cover!important;mask-size:cover!important;display:inline-block}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
